import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { TripFinanceService } from 'src/app/api/trip-finance.service';
import { OverDuePaymentsResponse, OverduePayment } from 'src/app/api/types/recruiting';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { DateTime } from 'luxon';
import { firstValueFrom } from 'rxjs';
import { RouterModule } from '@angular/router';
import { Column, TableColumnComponent, TableHeaderComponent } from 'src/app/ui/tables';


@Component({
  selector: 'app-my-overdue-regi-fees',
  templateUrl: './my-overdue-regi-fees.component.html',
  styleUrls: ['./my-overdue-regi-fees.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule, TableModule, ProgressBarModule, RouterModule, TableColumnComponent, TableHeaderComponent]
})
export class MyOverdueRegiFeesComponent implements OnInit {
  overdueFees = signal<OverduePayment[]>([]);
  paymentSummary: { totalPaid: number; totalDue: number } = { totalPaid: 0, totalDue: 0 };
  percentage: number = 0;

  columns: WritableSignal<Column<OverduePayment>[]> = signal([
    { field: 'groupName', header: 'Group Name', type: 'groupNameWithLink', custIdField: 'custID', sortable: true, filterable: true },
    { field: 'locationName', header: 'Location', type: 'text', sortable: true, filterable: true },
    { field: 'chargeDueDate', header: 'Due', type: 'date', sortable: true, filterable: true },
    { field: 'chargeAmount', header: 'Total', type: 'currency', sortable: true, filterable: true }
  ]);

  @Input() staffId: number = 0;

  constructor(
    private tripFinanceService: TripFinanceService
  ) {}

  ngOnInit() {
    this.loadOverdueFees();
  }

  private async loadOverdueFees() {
    if (!this.staffId) return;

    try {
      const response = await firstValueFrom(this.tripFinanceService.getOverdueRegiFeesForStaff(this.staffId));
      this.overdueFees.set(response.overduePayments);
      this.paymentSummary = response.paymentSummary;
      this.calculatePercentage();
    } catch (error) {
      // Error handling - could add user notification here if needed
    }
  }

  private calculatePercentage() {
    if (this.paymentSummary.totalDue > 0) {
      this.percentage = (this.paymentSummary.totalPaid / this.paymentSummary.totalDue) * 100;
    }
  }

  formatDate(date: Date): string {
    return DateTime.fromJSDate(date).toFormat('MM/dd/yy');
  }

  formatCurrency(amount: number): string {
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  getRemainingAmount(fee: OverduePayment): number {
    return fee.chargeAmount - fee.chargeAmountPaid - fee.discountAmount;
  }
} 